import { Create, TextInput, required, SimpleForm } from 'react-admin';
import { useParams } from 'react-router';
import { LoadingSection } from '../../common/LoadingSection';

const SectionCreate = () => {
    let { testSeriesId, testId } = useParams();

    if (!testSeriesId || !testId) {
        return <LoadingSection />;
    }
    return (
        <Create
            redirect={() => {
                return `test-series/${testSeriesId}/tests/${testId}/sections`;
            }}
            resource={'sections'}
        >
            <SimpleForm
                defaultValues={{
                    testSeriesId: testSeriesId,
                    testId: testId,
                }}
            >
                <TextInput source="name" fullWidth validate={[required()]} />
            </SimpleForm>
        </Create>
    );
};

export default SectionCreate;
